import React from 'react';

const WhatsAppSupport = () => {
  return (
    <div className="text-center">
      <h3 className="text-2xl font-bold mb-6 flex items-center justify-center gap-3">
        📱 WhatsApp Support
      </h3>
      <div className="bg-green-600 text-white p-8 rounded-2xl max-w-md mx-auto">
        <div className="text-6xl mb-4">📱</div>
        <h4 className="text-xl font-bold mb-2">Chat via WhatsApp</h4>
        <p className="mb-6">Hubungi tim support kami melalui WhatsApp untuk bantuan cepat</p>
        <div className="text-2xl font-bold mb-4">+62 811-2345-6789</div>
        <button className="bg-white text-green-600 px-6 py-3 rounded-xl font-semibold hover:bg-gray-100 transition-colors">
          Buka WhatsApp
        </button>
      </div>
    </div>
  );
};

export default WhatsAppSupport;